<template>
  <div class="buscar-navbar">
    <div class="buscar">
      <autocomplete :placeholder="$t('buscar')" class="sm-2" :search="search">
        <template #result="{ result, props }" :get-result-value="getResultValue">
          <li v-bind="props">
            <router-link :to="{ name: 'PlanPageDetalles', params:{ id: result.resolucion_poa_id}}">
              <h4 class="nombre-result">{{ result.numero_th }} | <span class="grupo-result">{{$t('buscador_menu_plan')}} {{ result.resolucion_poa }}</span></h4>
            </router-link>
          </li> 
        </template>
      </autocomplete>
    </div>
  </div>
</template>

<script>

  import { map, groupBy, uniq, filter, orderBy, sum } from 'lodash'
  import Autocomplete from '@trevoreyre/autocomplete-vue'
  import '@trevoreyre/autocomplete-vue/dist/style.css'

  export default {
    name: 'BuscadorMenuPlanes',
    props: {
      dataset: Array
    },
    components: {
      Autocomplete
    },
    data() {
      return {
        filters: [
          {value: "consultor_pmf_id", text: "Consultores y/o regentes forestales"},
          {value: "profesional_inf_tecnico_insp_ocular_id", text: "Profesional técnico en inspección ocular"},
          {value: "profesional_recomienda_aprueba_pmf_id", text: "Profesional que recomienda aprobación del plan"},
          {value: "funcionario_aprobo_pmf_id", text: "Funcionarios que aprobaron el plan"},
          {value: "representante_legal_id", text:"Representante legal"}
        ]
      }
    },
    methods: {
      search(input) {

        if (input.length < 1) { return [] }
        return filter(this.dataset, item => {
          console.log(item)
          if(item.numero_th.toLowerCase().startsWith(input.toLowerCase()) || item.resolucion_poa.toLowerCase().startsWith(input.toLowerCase())) {              
            return item
          }
        })
      },
      getResultValue(result) {
        return `${result.numero_th}`
      }
    },
    computed: {
      buscar() {
        let results = map(this.filters, f => {
          let dataFiltered = filter(this.dataset, item => (item[f.value] != 'nd' && item[f.value] != '*No indica' && item[f.value].typeof !== 'undefined' && item[f.value] !== '-'))
          return map(groupBy(dataFiltered, f.value), (rows, id) => {
            return {
              id: id,
              nombre: uniq(map(rows, f.value.replace("_id", ""))).join(""),
              planes: rows.length,
              departamentos: uniq(map(rows, 'departamento')),
              grupo: f.text
            }
          })
        })

        let data_result = orderBy(map(groupBy([].concat.apply([], results), 'nombre'), item => {
          return {
            id: uniq(map(item, 'id')).join(""),
            nombre: uniq(map(item, 'nombre')).join(""),
            planes: sum(map(item, 'planes')),
            roles: uniq(map(item, 'grupo')).length,
            grupos: uniq(map(item, 'grupo')).join(", "),
            departamentos: uniq([].concat.apply([], map(item, 'departamentos')))
          }
        }), ['planes', 'roles', 'departamentos'], ['desc', 'desc', 'departamentos'])

        return data_result
      }
    }
  }
    


</script>